import {Injectable} from '@angular/core'
import {AmplifyService} from '@flowaccount/aws-amplify-angular'
import {distinctUntilChanged, map, shareReplay} from 'rxjs/operators'

@Injectable({
  providedIn: 'root',
})
export class UserNameService {
  userName = this.amplify.authStateChange$
    .pipe(
      map(authState => authState.user?.username?.toLowerCase() || 'Nobody'),
      distinctUntilChanged(),
      shareReplay(1),
    )

  constructor(
    private amplify: AmplifyService,
  ) {
  }
}
